/**
 * 預繳名單區塊（SSOT）
 * MainPage（Group）與 SquareLandingPage（Square）共用
 */

import type { PrepaidListItem } from '../api/contextClient';
import { utcToTaipei } from '@pos/shared/utils/time';
import { GENDER_LABELS } from '../constants/labels';

export interface PrepaidListBlockProps {
  loading: boolean;
  items: PrepaidListItem[];
  emptyMessage?: string;
}

/**
 * 預繳名單表格：名稱、次數、性別、最近更新
 */
export function PrepaidListBlock({
  loading,
  items,
  emptyMessage = '尚無預繳名單',
}: PrepaidListBlockProps) {
  return (
    <div className="text-sm">
      {loading ? (
        <p className="text-muted-foreground">載入中...</p>
      ) : items.length === 0 ? (
        <p className="text-muted-foreground">{emptyMessage}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-2 px-2 font-medium text-gray-700">
                  名稱
                </th>
                <th className="text-right py-2 px-2 font-medium text-gray-700">
                  次數
                </th>
                <th className="text-center py-2 px-2 font-medium text-gray-700">
                  性別
                </th>
                <th className="text-right py-2 px-2 font-medium text-gray-700">
                  最近更新
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map(row => (
                <tr key={row.userId} className="border-b border-gray-100">
                  <td className="py-2 px-2 text-gray-900">{row.name}</td>
                  <td className="py-2 px-2 text-right text-gray-900">
                    {row.remainingCount}
                  </td>
                  <td className="py-2 px-2 text-center text-gray-600">
                    {row.gender
                      ? (GENDER_LABELS[row.gender] ?? row.gender)
                      : '—'}
                  </td>
                  <td className="py-2 px-2 text-right text-gray-600 text-xs">
                    {utcToTaipei(row.updatedAt).slice(0, 16).replace('T', ' ')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
